export const contactInfo = {
    mailTo: "info@grovefurnishings.ie",
    phone: "(074) 912 1064",
    page: "/page/contact",
    facebook: "https://www.facebook.com/grovefurnishings/",
    instagram: "https://www.instagram.com/grovefurnishings/?hl=en",
    twitter: "",
    pinterest: "",
    youtube: "",
    linkedin: ""
}

export const contactForm = {
    fields:
    {
        name: {
            required: false,
            showInput: true
        },
        email: {
            required: false,
            showInput: true
        },
        phone: {
            required: false,
            showInput: true
        },
        storeName: {
            required: false,
            showInput: false
        },
        message: {
            required: false,
            showInput: true
        },

    }
}

export const sendAMessage = {
    title: 'Contact',
    subtitle: 'Send Us a Message',
    description: 'Leave us a comment or ask us a question and we will get back to you as quickly as possible. Please, use the contact form.',
    callUs: {
        title: 'Call Us',
        subtitle: 'Our friendly and knowledgeable staff would be delighted to help you.',
    }
}

export const storeLocations = {
    title: 'Store Locations',
    subtitle: '',
    where: {
        title: 'Where We Operate',
        subtitle: 'Kiltoy Rd, Ballyboe Lisnenan, Letterkenny, Co. Donegal, F92 YW83',
        urlMap: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4581.484558467762!2d-7.706111!3d54.960081!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x485feb6ab6a44a99%3A0xf5850d0e46aa9993!2sEZ%20Living%20%40%20Grove%20Furnishings!5e0!3m2!1sen!2suy!4v1700084834375!5m2!1sen!2suy'
    },
    opening: {
        title: 'Opening Hours',
        subtitle: 'Monday-Friday  /  Saturday'
    }
}

export const  socialMediaMetadataInfo = {    
    urlImageSocial: '',
    urlTwitterImage: '',
}

export const showCaptcha = {
    visible: false,
    sitekey: "2ce7ad9b-d0ba-4b4a-b453-30dcdf4448ba", // (hcaptcha email= info@thewebsystem.com , password =BCEjzWCv_emg4R3)
    language: 'en'
}